import { action } from 'satcheljs/lib/legacy';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';

export default action('setIsSearching')(function setIsSearching(
    viewstate: FindControlViewState,
    isSearching: boolean
) {
    if (viewstate.isSearching != isSearching) {
        viewstate.isSearching = isSearching;
    }
});
